export const enum CONTENT_CHOICE {
  DEFAULT = 'default',
  CUSTOM = 'custom',
}
